<template>
  <div class="flex h-6 w-6 items-center justify-center">
    <component :is="getIcon()" :fill-color="fillColor" :width="width" :height="height" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, type Component } from 'vue'
import {
  StudyIcon,
  DashboardIcon,
  ExitIcon,
  SettingsIcon,
  CardsIcon,
  ChartIcon,
  CoachAIIcon,
  LoginIcon,
  BookIcon,
  UserIcon
} from '../../icons'
import { NavigationPaneActiveFillColor, COACH_AI_ID } from '../constants/navigationPaneDefaults'

// Static icon mapping object
const iconMappings: Record<string, Component> = {
  home: DashboardIcon,
  dashboard: DashboardIcon,
  study: BookIcon,
  practice: StudyIcon,
  analysis: ChartIcon,
  compete: CardsIcon,
  settings: SettingsIcon,
  exit: ExitIcon,
  login: UserIcon,
  logout: ExitIcon,
  coach_ai: CoachAIIcon
}

export default defineComponent({
  name: 'ItemIcon',
  props: {
    id: {
      type: String,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 24
    }
  },
  setup(props) {
    // Function to get the appropriate icon component based on ID
    const getIcon = () => {
      const id = props.id.toLowerCase()

      // Use the icon mapping object instead of switch statement
      return iconMappings[id] || DashboardIcon // Default fallback
    }

    // Calculate fill color based on selection state
    const fillColor = computed(() => {
      return props.isSelected ? '#FFFFFF' : NavigationPaneActiveFillColor
    })

    return {
      getIcon,
      fillColor
    }
  }
})
</script>
